import React from 'react';
import clsx from 'clsx';
import { Button, styled, type ButtonProps } from '@mui/material';

import Icon from '../Icon';
import Text from '../Text';

type ButtonLinkProps = Pick<ButtonProps, 'className' | 'children' | 'variant' | 'href'> & {
	/** The icon name */
	icon?: string;
	/** A fallback string if the children is not provided */
	fallback?: string;
};

const Root = styled('a')(({ theme }) => ({
	'&:not([role=button])[target=_blank]': {
		background: 'none',
		borderBottom: 'none',
		'&:hover': {
			background: 'none'
		}
	}
}));

/** A text component that, when clicked open a given link */
function ButtonLink({ children, className, fallback, icon, href, variant = 'text' }: ButtonLinkProps) {
	return (
		<Root href={children ? href : undefined} rel="noopener noreferrer" target="_blank">
			<Button
				className={clsx(className, 'min-w-28 max-w-full overflow-x-hidden p-4 text-left normal-case')}
				variant={variant}
				size="small"
				color={href ? 'secondary' : 'inherit'}
				disabled={!children}
				startIcon={icon ? <Icon icon={icon} /> : undefined}
			>
				<Text className="line-clamp-1">{children || fallback}</Text>
			</Button>
		</Root>
	);
}

export default React.memo(ButtonLink);
